export enum SortOrderEnum {
    ASC = 1,
    DESC = 2,
}
